<template>
  <van-calendar
    ref="calendar"
    v-model="show"
    :type="type"
    @confirm="onConfirm"
    :default-date="defaultDate"
    :formatter="formatter"
    :show-confirm="false"
    :color="color"
    :get-container="getContainer"
    :allow-same-day="allowSameDay"
    :readonly="rea"
    :min-date="new Date(mi)"
    :max-date="new Date(mi0)"/>
</template>
<script>
import {Calendar} from 'vant'
import {formatDate} from 'Utils/dateUtil'
import {mapGetters} from 'vuex'
import festival from './festival'


export default {
  name: 'LdCalendar',
  components: {
    [Calendar.name]: Calendar
  },
  props: {
    type: {
      type: String,
      default: 'single'
    },
    startText: {
      type: String,
      default: '入住'
    },
    endText: {
      type: String,
      default: '离店'
    },
    element: {
      type: String,
      default: ''
    },
    allowSameDay: Boolean,
    mi0:{
      type: String,
      default: '2026-06-06'
    }

  },
  data () {
    return {
      mi: new Date(),
      // mi0: '2025-03-20',
      rea: false,
      show: false,
      defaultDate: null,
      color: '',
      festival: festival,
      oldCon: '', // 日历原日期文字标识字段
    }
  },
  computed: {
    ...mapGetters(['loginConfig'])
  },
  mounted () {
    if (this.loginConfig) {
      if (this.loginConfig.themeBean) {
        if (this.loginConfig.themeBean.mainColor) this.color = this.loginConfig.themeBean.mainColor
      }
    }
  },
  methods: {
    formatter(day) {
      const month = day.date.getMonth() + 1
      const date = day.date.getDate()
      const today = formatDate(new Date())
      const tomorrow = formatDate(new Date(), 1)
      const year = day.date.getFullYear()
      let datex = `${year}/${month}/${date}`
      let datex2 = formatDate(day.date).date
      let yearall = this.festival[year][datex]
      if (yearall) {
        day.topInfo = yearall
        if(this.mi){
          if(new Date(this.mi) < new Date(day.date)){
            day.className = 'red'
          }
        }
      }
      if (month === 0 || month === 6) {
        day.className = 'weekendRed'
      }
      if (today.month == month) {
        if (today.d == date) {
          day.topInfo = '今天'
        }
      }
      if (tomorrow.month == month) {
        if (tomorrow.d == date) {
          day.topInfo = '明天'
        }
      }


      if (day.type === 'start') {
        day.bottomInfo = this.startText
      } else if (day.type === 'end') {
        day.bottomInfo = this.endText
      }else if(day.type=='start-end'){
        day.bottomInfo=`${this.startText}/${this.endText}`
      }
      let obj2025 = {
        '2025/1/1': '元旦',
        '2025/1/28': '除夕',
        '2025/1/29': '春节',
        '2025/3/8': '妇女节',
        '2025/4/5': '清明节',
        '2025/5/1': '劳动节',
        '2025/6/1': '儿童节',
        '2025/6/12': '端午节',
        '2025/7/1': '建党节',
        '2025/8/1': '建军节',
        '2025/8/18': '七夕',
        '2025/9/10': '教师节',
        '2025/10/1': '国庆节',
        '2025/12/24': '平安夜',
        '2025/12/25': '圣诞节',
      }
      if (year == '2025') {
        let datex = `${year}/${month}/${date}`
        day.topInfo = obj2025[datex]
      }

      if (this.oldCon != '') {
        if (this.oldCon == datex2) {
          day.bottomInfo = '原'
          day.className = 'oldContent'
        }
      }
      return day
    },
    onConfirm (date) {
      this.show = false
      let resault = ''
      if (Array.isArray(date)) {
        resault = [formatDate(date[0]).date, formatDate(date[1]).date]
      } else {
        resault = formatDate(date).date
      }
      this.$emit('selected', resault)
    },
    toggle (props) {
      this.show = !this.show
      if (props) {
        if (props.defaultDate) {//默认选中日期
          if (Array.isArray(props.defaultDate)) {//多日期
            let arr = []
            props.defaultDate.forEach(item => {
              arr.push(formatDate(item).datetime)
            })
            this.defaultDate = arr
            this.$refs.calendar.scrollToDate(arr[0])//滚动到 选中日期
          } else {//单日期
            this.defaultDate = formatDate(props.defaultDate).datetime
            this.$refs.calendar.scrollToDate(this.defaultDate)
          }
        }
        //判断 是否有日期单位限制
        if (props.minDate) {
          this.mi = formatDate(props.minDate).datetime
        }
        if (props.maxDate) {
          this.mi0 = formatDate(props.maxDate).datetime
        }
      }
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer () {
      if (this.element) {
        return document.querySelector(this.element)
      }
      return ''
    },

    //给日期加一个改签原日期（原）
    addOldContent(item) {
      this.oldCon = item.departDate
      if (item.changeMap) {
        //如果有改签记录就用新的改签日期没有
        this.oldCon = item.changeMap.newDepartDate
      }
    },
  },
}
</script>
<style scoped>

</style>
